import RegisterPartnerJsSerializer from './-json-api';

export default class OrganizationSerializer extends RegisterPartnerJsSerializer {}
